<template>
  <div class="options">
    <div class="backdrop"></div>
    <div class="content">
      <div class="close" @click="cancel">×</div>
      <NewTranslation class="title" path="logout.title"></NewTranslation>
      <NewTranslation class="description" path="logout.description"></NewTranslation>
      <div class="form">
        <Button class="button" color="green" @click.native="confirm" path="logout.confirm.button"></Button>
        <Button class="button" @click.native="cancel" path="logout.back.button"></Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';
import AuthApi from '@/app/api/AuthApi';

export default {
  components: {
    NewTranslation,
    Button,
  },
  props: ['overlaydata'],
  methods: {
    cancel() {
      this.$store.commit('openOverlay', '');
    },
    confirm() {
      // @DEBUG
      AuthApi.logout().then(() => {
        this.$store.dispatch('logoutUser');
        this.$router.push({ name: this.$namedRoutes.splash });
      });
      this.$store.commit('openOverlay', '');
    },
  },
};
</script>

<style lang="sass" scoped>
.options
	width: 100%
	height: 100vh
	display: flex
	flex-direction: column
	align-items: center
	justify-content: center
	position: fixed
	max-width: 480px
	margin: 0 auto
	right: 0
	top: 0
	left: 0
	z-index: 9
.backdrop
	background-color: rgba(0, 0, 0, .8)
	width: 100%
	height: 100vh
	position: absolute
	z-index: 6
.close
	position: absolute
	right: 20px
	top: 20px
	background-color: #fff
	z-index: 9
	color: #1DB2D1
	border: 1px solid #1DB2D1
	width: 20px
	height: 20px
	display: flex
	justify-content: center
	align-items: center
	border-radius: 20px
	user-select: none
.content
	z-index: 7
	background-color: #fff
	border-radius: 10px
	padding: 20px
	margin: 20px
	position: relative
.title
	display: block
	font-size: 20px
	color: #1DB2D1
	text-align: center
	padding-left: 30px
	padding-right: 30px
.description
	display: block
	text-align: center
	color: #454F63
	margin-top: 20px
.form
	margin-top: 20px
	.button
		margin-top: 20px
</style>
